export interface BroadcastService {
  postMessage(event: string, data?: unknown): void;
  onMessage(handler: (event: string, data: unknown) => void): () => void;
}

interface BroadcastPayload {
  event: string;
  data: unknown;
}

export class BrowserBroadcastService implements BroadcastService {
  private readonly channel: BroadcastChannel;

  constructor(channelName: string) {
    this.channel = new BroadcastChannel(channelName);
  }

  postMessage(
    event: string,
    data?: unknown
  ): void {
    const payload: BroadcastPayload = { event, data: data ?? null };
    this.channel.postMessage(payload);
  }

  onMessage(handler: (event: string, data: unknown) => void): () => void {
    const listener = (ev: MessageEvent) => {
      const msg = ev.data as Partial<BroadcastPayload> | undefined;
      if (!msg || typeof msg.event !== 'string') {
        return;
      }
      handler(msg.event, msg.data);
    };

    this.channel.addEventListener('message', listener);

    return () => {
      this.channel.removeEventListener('message', listener);
    };
  }
}
